import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faSave,
  faTimesCircle,
  faCalendarAlt,
  faClipboardCheck,
  faFileAlt,
  faCompass,
  faUserMd,
  faMicroscope,
  faUsers,
  faClipboardList,
  faProcedures,
  faArrowRight,
  faHandHoldingMedical,
  faHeartbeat,
  faComments,
  faClock,
  faRoute,
  faHourglassHalf,
} from "@fortawesome/free-solid-svg-icons";

import api from "../../services/client/api";
import { ModalWrapper } from "./styles";
import { Button, Alert, Spinner, Fade } from "reactstrap";

// Tema visual de cada desfecho
const desfechoThemes = {
  1: {
    color: "#15803D",
    bg: "#F0FDF4",
    border: "#86EFAC",
    icon: faCheck,
  },
  2: {
    color: "#2563EB",
    bg: "#EFF6FF",
    border: "#93C5FD",
    icon: faClock,
  },
  3: {
    color: "#0F766E",
    bg: "#F0FDFA",
    border: "#5EEAD4",
    icon: faFileAlt,
  },
  4: {
    color: "#7C3AED",
    bg: "#F5F3FF",
    border: "#C4B5FD",
    icon: faCompass,
  },
  5: {
    color: "#9333EA",
    bg: "#FAF5FF",
    border: "#D8B4FE",
    icon: faUserMd,
  },
  6: {
    color: "#0369A1",
    bg: "#F0F9FF",
    border: "#7DD3FC",
    icon: faMicroscope,
  },
  7: {
    color: "#6D28D9",
    bg: "#F5F3FF",
    border: "#C4B5FD",
    icon: faUsers,
  },
  8: {
    color: "#4338CA",
    bg: "#EEF2FF",
    border: "#A5B4FC",
    icon: faClipboardList,
  },
  9: {
    color: "#B91C1C",
    bg: "#FEF2F2",
    border: "#FCA5A5",
    icon: faProcedures,
  },
  10: {
    color: "#C2410C",
    bg: "#FFF7ED",
    border: "#FDBA74",
    icon: faArrowRight,
  },
  11: {
    color: "#047857",
    bg: "#ECFDF5",
    border: "#6EE7B7",
    icon: faHandHoldingMedical,
  },
  12: {
    color: "#0D9488",
    bg: "#F0FDFA",
    border: "#99F6E4",
    icon: faHeartbeat,
  },
  13: {
    color: "#A16207",
    bg: "#FEFCE8",
    border: "#FDE047",
    icon: faComments,
  },
  14: {
    color: "#C2410C",
    bg: "#FFF7ED",
    border: "#FDBA74",
    icon: faHourglassHalf,
  },
  15: {
    color: "#BE185D",
    bg: "#FDF2F8",
    border: "#F9A8D4",
    icon: faRoute,
  },
};

const getDesfechoTheme = (cod) =>
  desfechoThemes[cod] || {
    color: "#475569",
    bg: "#F8FAFC",
    border: "#CBD5E1",
    icon: faClipboardCheck,
  };

const Desfecho = ({
  token,
  username,
  onClose,
  report,
  refreshReports,
  action,
}) => {
  const [desfechos, setDesfechos] = useState([]);
  const [dataDesfecho, setDataDesfecho] = useState("");
  const [selectedDesfecho, setSelectedDesfecho] = useState(null);
  const [alertInsert, setAlertInsert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchDesfecho = async () => {
      try {
        const response = await api().user().getDesfecho(token);

        if (response.status === 200) {
          const ordered = [...response.output].sort(
            (a, b) => a.Ordem - b.Ordem
          );

          setDesfechos(ordered);
        }
      } catch (err) {
        console.error("Erro ao buscar desfechos:", err);
      }
    };

    fetchDesfecho();
  }, [token]);

  useEffect(() => {
    if (report) {
      setSelectedDesfecho(
        report.CodDesfecho != null
          ? Number(report.CodDesfecho)
          : null
      );

      if (report.DtaDesfecho) {
        const formattedDate = new Date(report.DtaDesfecho)
          .toISOString()
          .split("T")[0];

        setDataDesfecho(formattedDate);
      } else {
        setDataDesfecho(new Date().toISOString().split("T")[0]);
      }
    }
  }, [report]);

  const handleSave = async () => {
    if (!selectedDesfecho) {
      setErrorMessage("Selecione um desfecho.");
      return;
    }

    if (!dataDesfecho) {
      setErrorMessage("Informe a data do desfecho.");
      return;
    }

    setErrorMessage("");

    try {
      const payload = {
        CodDesfecho: selectedDesfecho,
        DtaDesfecho: dataDesfecho,
        CodRequisicao: report.CodRequisicao,
        username,
      };

      const response = await api()
        .user()
        .insertDesfecho(token, payload);

      if (response.status === 201) {
        setAlertInsert(true);

        setTimeout(() => {
          onClose();
          refreshReports();
        }, 2000);
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
      setErrorMessage("Não foi possível salvar o desfecho.");
    }
  };

  const handleUpdate = async () => {
    if (!selectedDesfecho) {
      setErrorMessage("Selecione um desfecho.");
      return;
    }

    if (!dataDesfecho) {
      setErrorMessage("Informe a data do desfecho.");
      return;
    }

    setErrorMessage("");

    try {
      const payload = {
        CodDesfecho: selectedDesfecho,
        DtaDesfecho: dataDesfecho,
        CodRequisicao: report.CodRequisicao,
        username,
      };

      const response = await api()
        .user()
        .updateDesfecho(token, payload);

      if (response.status === 200) {
        setAlertInsert(true);

        setTimeout(() => {
          onClose();
          refreshReports();
        }, 2000);
      }
    } catch (error) {
      console.error("Erro ao atualizar:", error);
      setErrorMessage("Não foi possível atualizar o desfecho.");
    }
  };

  const handleSubmit = () => {
    if (action === "insert") {
      handleSave();
    } else if (action === "update") {
      handleUpdate();
    }
  };

  return (
    <ModalWrapper>
      {alertInsert ? (
        <Fade>
          <Alert color="success" className="success-alert">
            <b>
              Desfecho salvo com sucesso{" "}
              <FontAwesomeIcon icon={faCheck} />
            </b>

            <div>
              Retornando para a listagem{" "}
              <Spinner size="sm" />
            </div>
          </Alert>
        </Fade>
      ) : (
        <>
          <div className="modal-header">
            <div className="header-icon">
              <FontAwesomeIcon icon={faClipboardCheck} />
            </div>

            <div className="header-content">
           
              <h2>
                {action === "insert"
                  ? "Definir desfecho"
                  : "Atualizar desfecho"}
              </h2>

              <p>
                Selecione o desfecho e informe a data correspondente.
              </p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={onClose}
              aria-label="Fechar modal"
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </button>
          </div>

          {errorMessage && (
            <Alert color="danger" className="error-alert">
              <b>{errorMessage}</b>
            </Alert>
          )}

          <div className="section-heading">
            <div>
              <h3>Qual é o desfecho?</h3>
              <p>Escolha uma das opções abaixo.</p>
            </div>

            <span
              className={`selection-counter ${
                selectedDesfecho ? "has-selection" : ""
              }`}
            >
              {selectedDesfecho
                ? "1 selecionado"
                : "Nenhum selecionado"}
            </span>
          </div>

          <div className="desfecho-grid">
            {desfechos.map((item) => {
              const theme = getDesfechoTheme(item.CodDesfecho);

              const isSelected =
                Number(selectedDesfecho) ===
                Number(item.CodDesfecho);

              return (
                <button
                  key={item.CodDesfecho}
                  type="button"
                  className={`desfecho-card ${
                    isSelected ? "selected" : ""
                  }`}
                  style={{
                    "--card-color": theme.color,
                    "--card-bg": theme.bg,
                    "--card-border": theme.border,
                  }}
                  onClick={() => {
                    setSelectedDesfecho(
                      Number(item.CodDesfecho)
                    );
                    setErrorMessage("");
                  }}
                  aria-pressed={isSelected}
                >
                  <span className="card-icon">
                    <FontAwesomeIcon icon={theme.icon} />
                  </span>

                  <span className="card-label">
                    {item.Desfecho}
                  </span>

                  <span className="card-check">
                    {isSelected && (
                      <FontAwesomeIcon icon={faCheck} />
                    )}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="date-section">
            <div className="date-label">
              <span className="date-icon">
                <FontAwesomeIcon icon={faCalendarAlt} />
              </span>

              <div>
                <label htmlFor="dataDesfecho">
                  Data do desfecho
                </label>

                <p>
                  Informe a data correspondente ao registro.
                </p>
              </div>
            </div>

            <input
              id="dataDesfecho"
              type="date"
              value={dataDesfecho}
              onChange={(e) =>
                setDataDesfecho(e.target.value)
              }
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
            >
              Cancelar
            </button>

            <Button
              type="button"
              color="primary"
              className="save-button"
              onClick={handleSubmit}
            >
              <FontAwesomeIcon icon={faSave} />

              {action === "insert"
                ? "Salvar desfecho"
                : "Atualizar desfecho"}
            </Button>
          </div>
        </>
      )}
    </ModalWrapper>
  );
};

export default Desfecho;